import React, { useContext } from "react";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

export default function Antecedentes() {
  const {
    antecedentes,
    obtenerAntecedentes,
    agregarAntecedente,
    actualizarAntecedente,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Antecedentes"
      entidad="antecedente"
      layout="Antecedentes"
      icono={<MonitorHeartOutlinedIcon />}
      items={antecedentes}
      onObtener={() => obtenerAntecedentes({ todos: true })}
      onAgregar={(data) => agregarAntecedente({ antecedente: data })}
      onActualizar={(data) => actualizarAntecedente({ antecedente: data })}
    />
  );
}
